"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkCompatibility = checkCompatibility;
const DECISION_STEP_TYPES = ['decision', 'decision_externalcrm', 'decision-now', 'decision-payment'];
// Check if a given `advanced-query` step is compatible
// with the new process builder.
function isCompatibleAdvancedQuery(step) {
  // It must end with the `stop` step.
  if (!step.steps_if_true.length || step.steps_if_true[step.steps_if_true.length - 1].type !== 'stop') {
    return false;
  }
  // It should not have any nested-ifs
  // nor stage-change, go-to-workflow steps.
  const nested = step.steps_if_true.find(subStep => {
    return subStep.type === 'advanced-query' || DECISION_STEP_TYPES.includes(subStep.type) || subStep.type === 'stage-change' || subStep.type === 'go-to-workflow';
  });
  if (nested) {
    return false;
  }
  return true;
}
/**
 * Check if a given custom process is compatible
 * with the new process builder.
 * @returns `true` if compatible, `false` otherwise.
 */
function checkCompatibility(process) {
  // If it has any `decision` steps, it is incompatible.
  const decisionStep = process.find(step => {
    return DECISION_STEP_TYPES.includes(step.type);
  });
  if (decisionStep) {
    return false;
  }
  // If it has any incompatible `advanced-query` steps,
  // it is incompatible.
  let nonAdvancedQueryStepAppeared = false;
  const incompatibleStep = process.find(step => {
    if (step.type === 'stage-change' || step.type === 'go-to-workflow') {
      return true;
    }
    if (step.type === 'advanced-query') {
      if (!isCompatibleAdvancedQuery(step)) {
        return true;
      }
      // `advanced-query` step cannot appear
      // after non-advanced-query step.
      // Non-advanced-query steps must appear
      // after all `advanced-query` steps.
      if (nonAdvancedQueryStepAppeared) {
        return true;
      }
    } else {
      nonAdvancedQueryStepAppeared = true;
    }
    return false;
  });
  return typeof incompatibleStep === 'undefined';
}
